import React from "react";
import { RouteObject } from "react-router";
import RootError from "../Component/Error/RootError";
import customerRoute from "./customer";
import publicRoute from "./public";
import RootComponent from "./RootComponent";
import agroManagerRoute from "./auth/agromanager/callback";

const routes: RouteObject = {
  Component: RootComponent,
  errorElement: React.createElement(RootError),
  children: [publicRoute, customerRoute, agroManagerRoute],
};

export default routes;
